/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

import { createGlobalStyle } from "styled-components";

interface CustomAPI {
  id?: string;
  name: string;
  endpoint: string;
  region: string;
}

interface EnprodConfig {
  oid?: string;
  uid?: string;
  ctype?: number;
  curl?: string;
  cid?: string;
  api?: string;
  apiid?: string;
  title?: string;
  mainColor1?: string;
  mainColor2?: string;
  domain?: string;
  adminpoolid?: string;
  adminclientid?: string;
  apiname?: string;
  webinvokeurl?: string;
  admininvokeurl?: string;
  adminapiname?: string;
  adminapiid?: string;
  webapiname?: string;
  webapiid?: string;
  SCHEMA_NAME?: string;
  defaultTenant?: string;
  defaultSTID?: number;
  mt_id?: number;
  secretKey?: string;
  secretKeyAfter?: string;
  OPENAI_API_KEY?: string;
  ENDPOINT?: string;
  aws_project_region?: string;
  aws_cloud_logic_custom?: CustomAPI[];
  aws_cognito_region?: string;
  aws_user_pools_id?: string;
  aws_user_pools_web_client_id?: string;
  aws_org_id?: string;
  main_color_1?: string;
  main_color_2?: string;
  platform_main_theme?: string;
  button_color_web?: string;
  aws_cloudfront_url?: string;
  DOMAIN?: string;
  aws_cloudfront_lurl?: string;
  learningpath?: boolean;
  appVersion?: string;
  auth_url?: string;
  schema?: string;
  aws_cloud_logic_custom_endpoint?: string;
  aws_cloud_logic_custom_name?: string;
  signUp?: boolean;
  profileSet?: string;
  home?: string;
  header?: string;
  ratingFeature?: string;
  course?: string;
  socialLearning?: boolean;
  competency?: boolean;
  activeUsers?: boolean;
  sessiontimeout?: number;
  sessiontimeoutalert?: number;
  sarasEAssessment?: any;
  admindomain?: string;
  razorPayId?: string;
  external_api?: string;
  excelearnsso?: boolean;
  sso?: any;
  livesession?: any;
  badgesbaseurl?: string;
  iciciprusso?: boolean;
  other_org_text?: string;
  sso_login_text?: string;
  xapi_credentials?: any;
  typesOfContent?: any;
  webUrl?: any;
  aws_cognito_identity_pool_id?: any;
}

export const Theme = {
  color: {
    primary: "#FF6F4D",
    secondary: "#275780",
    appGray: "#7c7f91",
    secondaryLight: "rgba(40, 87, 129, 0.2)",
    grey_light_1: "#f7f7f7",
    grey_light_2: "#eee",

    grey_dark: "#777",
    grey_dark_2: "#999",
    grey_dark_3: "#333",

    white: "#fff",
    black: "#000",
  },
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  backDropOpacity: "rgba(0, 0, 0, 0.85)",
};

export const GlobalStyle = createGlobalStyle`
/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Remove default margin */
body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
  margin: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role='list'],
ol[role='list'] {
  list-style: none;
}

/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}

/* Set core body defaults */
body {
  height: 100vh;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
  overflow-x: hidden;
  font-family: "graphic",sans-serif;
  
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
img,
picture {
  max-width: 100%;
  display: block;
}

/* Inherit fonts for inputs and buttons */
input,
button,
textarea,
select {
  font: inherit;
}



/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
   scroll-behavior: auto;
  }
  
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
.swal2-container {
  z-index: 100000;
}
.MuiSnackbar-root{
  z-index: 100000;
}
body{
  overflow-y: visible !important;
}
`;

const nextgen_web_prod_usp: EnprodConfig = {
  oid: "USP",
  ctype: 0,
  curl: "dcehm8us3h7nu.cloudfront.net",
  apiid: "cpz5g216nc",
  title: "USP",
  mainColor1: "#304885",
  main_color_1: "#371376",
  mainColor2: "#F5B001",
  domain: "dcehm8us3h7nu.cloudfront.net",
  webinvokeurl: "https://cpz5g216nc.execute-api.ap-south-2.amazonaws.com/prod",
  webapiid: "cpz5g216nc",
  SCHEMA_NAME: "usp",
  defaultTenant: "Default Team",
  defaultSTID: 1,
  mt_id: 1,
  aws_project_region: "ap-south-2", // AWS Region
  aws_cloud_logic_custom: [
    {
      id: "cpz5g216nc",
      name: "prod-nextgen-web",
      endpoint: "https://cpz5g216nc.execute-api.ap-south-2.amazonaws.com/prod",
      region: "ap-south-2",
    },
    // Add more custom APIs as needed
  ],
  aws_cloud_logic_custom_name: "prod-nextgen-web",
  // aws_cognito_region: "eu-west-2", // Amazon Cognito region

  aws_org_id: "USP",
  aws_cloudfront_url: "www.usp.enhanzed.com",
  schema: "usp",
  aws_cognito_identity_pool_id:
    "us-east-1:f6c1c940-5cc0-4779-9813-d1f4ca08f60a",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "ap-south-1_8xUeK3rFi",
  aws_user_pools_web_client_id: "1ocpjbt5jfb937b6l6pclmb16",
};

export default nextgen_web_prod_usp;
